import React, { useState } from "react";
import { supabase } from "./supabaseClient";

function UsernamePicker({ user, onUsernameSet }) {
  const [username, setUsername] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = username.trim().toLowerCase();

    if (!trimmed.match(/^[a-z0-9_]{3,20}$/)) {
      setError("Username must be 3-20 chars: letters, numbers, or underscore.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      // 1. Check uniqueness in Supabase "users" table
      const { data: existingUser, error: checkError } = await supabase
        .from("users")
        .select("id")
        .eq("username", trimmed)
        .maybeSingle();

      if (checkError) throw checkError;

      if (existingUser) {
        setError("Username already taken, try another.");
        setLoading(false);
        return;
      }

      // 2. Update user row in "users" table
      const userId = user.id || user.uid; // Compatible with both Supabase and Firebase user objects

      const { error: updateError } = await supabase
        .from("users")
        .update({ username: trimmed })
        .eq("id", userId);

      if (updateError) throw updateError;

      onUsernameSet(trimmed);
    } catch (err) {
      setError("Failed to save username.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Pick a username</h2>
      <form onSubmit={handleSubmit}>
        <input
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Enter username"
          autoFocus
          disabled={loading}
        />
        <button type="submit" disabled={loading}>
          {loading ? "Saving..." : "Save"}
        </button>
      </form>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <p>3-20 characters: letters, numbers, underscore only.</p>
    </div>
  );
}

export default UsernamePicker;